/**
 * Translates date strings that contain Albanian month names into the active UI
 * language. Used by components that render pre-formatted date strings like
 * "23-24 Tetor 2026" so they adapt when the user switches language.
 *
 * Keep this file in sync with the month list used by backend DB seed data.
 */
const ALBANIAN_MONTHS = [
  "Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor",
  "Korrik", "Gusht", "Shtator", "Tetor", "Nëntor", "Dhjetor",
];

const MONTH_TRANSLATIONS = {
  sq: ALBANIAN_MONTHS,
  en: ["January", "February", "March", "April", "May", "June",
       "July", "August", "September", "October", "November", "December"],
  it: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
       "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
  de: ["Januar", "Februar", "März", "April", "Mai", "Juni",
       "Juli", "August", "September", "Oktober", "November", "Dezember"],
  fr: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
       "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  mk: ["Јануари", "Февруари", "Март", "Април", "Мај", "Јуни",
       "Јули", "Август", "Септември", "Октомври", "Ноември", "Декември"],
  el: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος",
       "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"],
};

/**
 * Translate an Albanian-date string into the target language. Handles both
 * singular and plural references ("5 Qershor 2026", "5-6 Qershor 2026",
 * "Qershor - Tetor 2026", etc.) by replacing every Albanian month token with
 * its localized equivalent. The original string is returned unchanged when
 * the target language is Albanian or unsupported.
 */
export const translateDate = (dateStr, lang = "sq") => {
  if (!dateStr || typeof dateStr !== "string") return dateStr;
  if (!lang || lang === "sq") return dateStr;
  const months = MONTH_TRANSLATIONS[lang];
  if (!months) return dateStr;
  let out = dateStr;
  ALBANIAN_MONTHS.forEach((m, i) => {
    out = out.replace(new RegExp(m, "g"), months[i]);
  });
  return out;
};

export default translateDate;
